import React, { Component } from "react";
import { PropTypes } from "prop-types";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import t from "@zendesk/client-i18n-tools";
import { Pagination } from "@zendeskgarden/react-pagination";
import { getCurrentBrandId } from "@zendesk/knowledge-context";
import { Droppable, Draggable } from "react-beautiful-dnd";
import * as actions from "../../actions/section";
import SectionRow from "../SectionRow";
import styles from "./index.css";

export class SectionList extends Component {
  constructor(props) {
    super(props);

    this.onSectionClicked = this.onSectionClicked.bind(this);
    this.onSectionMoveTo = this.onSectionMoveTo.bind(this);
  }

  onSectionClicked(sectionId) {
    const { dispatch } = this.props;

    dispatch(
      push({
        pathname: `/knowledge/arrange/sections/${sectionId}`,
        search: `?brand_id=${getCurrentBrandId()}`,
      })
    );
  }

  onSectionMoveTo(sectionId, destinationOption, sourceIndex) {
    const { dispatch } = this.props;
    const {
      id: destinationOptionId,
      type: destinationOptionType,
    } = destinationOption;

    destinationOptionType === "Section"
      ? dispatch(
          actions.moveSectionToSection(
            sectionId,
            destinationOptionId,
            sourceIndex
          )
        )
      : dispatch(
          actions.moveSectionToCategory(
            sectionId,
            destinationOptionId,
            sourceIndex
          )
        );
  }

  renderSections() {
    const {
      sections,
      isFetching,
      pageCount,
      page,
      onPageSelected,
      count,
      isMoving,
      sectionSavingId,
      sectionSuccessId,
      onMoveToTop,
    } = this.props;

    if (isFetching) {
      return (
        <div
          className={styles.loader}
          style={{ height: `${Math.min(count, 5) * 73}px` }}
        />
      );
    }

    const pagination = pageCount > 1 && (
      <div data-test-id="sections-pagination">
        <Pagination
          totalPages={pageCount}
          currentPage={page}
          onChange={onPageSelected}
        />
      </div>
    );

    return (
      <div>
        <div>
          {sections.map((section, index) => (
            <Draggable
              isCombineEnabled
              key={section.id}
              type="section"
              draggableId={section.id}
              index={index}
              isDragDisabled={isMoving}
            >
              {(providedDraggable, snapshotDraggable) => (
                <Droppable droppableId={`section-${section.id}`} type="article">
                  {(providedDroppable, snapshotDroppable) => (
                    <div
                      className={styles.draggable}
                      ref={providedDraggable.innerRef}
                      {...providedDraggable.draggableProps}
                      style={{
                        ...providedDraggable.draggableProps.style,
                        opacity: 1,
                      }}
                    >
                      <div
                        ref={providedDroppable.innerRef}
                        {...providedDroppable.droppableProps}
                      >
                        <SectionRow
                          onClick={() => this.onSectionClicked(section.id)}
                          onMoveToTop={() => onMoveToTop(section, index)}
                          testId="section-item"
                          key={section.id}
                          section={section}
                          saving={sectionSavingId === section.id}
                          success={sectionSuccessId === section.id}
                          highlight={
                            snapshotDroppable.isDraggingOver ||
                            snapshotDraggable.combineTargetFor !== null
                          }
                          dragHandleProps={providedDraggable.dragHandleProps}
                          onMoveTo={destinationOption =>
                            this.onSectionMoveTo(
                              section.id,
                              destinationOption,
                              index
                            )
                          }
                        />
                      </div>
                    </div>
                  )}
                </Droppable>
              )}
            </Draggable>
          ))}
        </div>
        {pagination}
      </div>
    );
  }

  render() {
    const { count } = this.props;

    if (count === 0) {
      return null;
    }

    return (
      <div className={styles.container}>
        <h3 className={styles.listHeader}>
          {t("knowledge-arrange.sections.pageTitle", { count })}
        </h3>

        <Droppable droppableId="sections" type="section" isCombineEnabled>
          {(provided, snapshot) => (
            <div ref={provided.innerRef} {...provided.droppableProps}>
              {this.renderSections()}
            </div>
          )}
        </Droppable>
      </div>
    );
  }
}

SectionList.propTypes = {
  dispatch: PropTypes.func,
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      edit_url: PropTypes.string.isRequired,
      html_url: PropTypes.string.isRequired,
      section_count: PropTypes.number.isRequired,
      article_count: PropTypes.number.isRequired,
    })
  ).isRequired,
  count: PropTypes.number.isRequired,
  isFetching: PropTypes.bool.isRequired,
  pageCount: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  onPageSelected: PropTypes.func,
  onMoveToTop: PropTypes.func,
  sectionSavingId: PropTypes.number,
  sectionSuccessId: PropTypes.number,
  isMoving: PropTypes.bool,
};

const mapStateToProps = ({ sections }) => {
  return {
    sections: sections.list,
    isFetching: sections.isFetching,
    pageCount: sections.pageCount,
    sectionSavingId: sections.savingId,
    sectionSuccessId: sections.successId,
    isMoving: sections.isMoving,
  };
};

export default connect(mapStateToProps)(SectionList);



// WEBPACK FOOTER //
// ./src/components/SectionList/index.js